export default __webpack_public_path__ + "static/media/angbao-bonus-raya.391dc897.webp";